const {required} = require("@common/react/cs-form/validators/required");

exports.tableFormConfig = {
    fields: {
        title: {
            transforms: ["trim"],
            validators: [required],
            debounce: true,
        },
    },
};
